<button 
  class="filter-chip"
  type="button"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  (click)="onChipClick($event)"
  [attr.aria-label]="text">
  <span class="filter-chip-label">{{ text }}</span>
  <button 
    *ngIf="removable"
    type="button"
    class="filter-chip-remove"
    (click)="onRemoveClick($event)"
    [attr.aria-label]="'Remove ' + text">
    <umss-icon name="phosphorX" size="12px"></umss-icon>
  </button>
</button>